
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Bushireforweddinginpune() {



  const cardData =
  {
    keyword: ' Bus Hire for Wedding in Pune',
    heading: 'Vaishnavi Travels: Bus Hire for Wedding in Pune',
    headingDescription: 'Vaishnavi Travels provides reliable and budget-friendly Bus Hire for Wedding in Pune, ensuring smooth and convenient transport for your special day. Our fleet of well-maintained buses offers spacious seating, powerful air-conditioning, and ample luggage capacity to make every journey comfortable for guests and family members. With professional drivers, timely service, and flexible booking options, we handle all your wedding travel needs—from guest shuttles and venue transfers to outstation pickups. Whether it’s a traditional ceremony or a destination wedding, Vaishnavi Travels guarantees safe, comfortable, and hassle-free transportation, allowing you to celebrate every moment without any travel worries.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

    "topPlaces": [
      {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, its mighty gates, gardens, and ruins narrate tales of Maratha pride. Though partially destroyed by fire in 1828, its charm continues to draw thousands. The light-and-sound show in the evening brings alive the grandeur of Bajirao and Mastani. Visitors love exploring its historic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
      },
      {
        "title": "Aga Khan Palace",
        "description": "The Aga Khan Palace, built in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum with Gandhi’s belongings and photographs. The palace’s Italian arches and sprawling gardens add architectural charm. Its calm and serene ambiance makes it a popular tourist spot. Aga Khan Palace is Pune’s historic and inspirational gem."
      },
      {
        "title": "Sinhagad Fort",
        "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha bravery. Monsoon adds mist and waterfalls, making the trek even more scenic. Locals serve rustic delicacies like pithla-bhakri at the fort. Sinhagad is Pune’s blend of history, nature, and adventure."
      },
      {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established more than 125 years ago, the temple houses a magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also renowned for its charitable and cultural initiatives. Devotees and tourists alike are drawn to its vibrant spiritual aura. Dagdusheth Temple is Pune’s divine and cultural heart."
      },
      {
        "title": "Pataleshwar Cave Temple",
        "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The temple features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it offers peace and a spiritual retreat. Its architecture showcases ancient Indian craftsmanship. Evening prayers and chants enhance the temple’s mystical ambiance. Pataleshwar is Pune’s hidden spiritual heritage gem."
      },
      {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and daily-use antiques. The recreated Mastani Mahal is a highlight of the museum. History enthusiasts and students find it highly educational and fascinating. The museum preserves traditions spanning centuries of Indian culture. It is Pune’s proud showcase of heritage and art."
      },
      {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill, one of Pune’s oldest heritage landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, it also houses museums and smaller shrines. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. Sunrise and sunset views from here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
      },
      {
        "title": "Osho Ashram",
        "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls enhance the experience. It is a haven for peace, rejuvenation, and mindfulness. Osho Ashram is Pune’s international center of tranquility."
      },
      {
        "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
        "description": "Pu La Deshpande Garden, inspired by the Korakuen Garden in Japan, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy picnics, photography, and peaceful strolls in its serene setting. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
      },
      {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. The dam supplies water to the city while offering scenic views of hills and flowing waters. During monsoon, the overflowing dam creates spectacular sights. Street vendors sell hot corn and tea along the banks, adding to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat for families and travelers alike."
      }
    ],


    "services": [
  {
    "name": "Wedding Guest Bus Hire Pune",
    "description": "Specialized wedding guest bus hire service in Pune designed for smooth, coordinated group travel between venues, hotels, and residences. These buses ensure your guests travel comfortably and on time, with optional decorations, trained drivers, and real-time tracking support. Ideal for managing transportation across multiple wedding functions."
  },
  {
    "name": "AC Bus for Marriage in Pune",
    "description": "Fully air-conditioned buses available for marriage functions in Pune, offering a cool, pleasant ride for guests even during peak summer or long commutes. Each bus comes with plush seating, ample legroom, and well-maintained interiors. Perfect for keeping your wedding attendees refreshed and comfortable in traditional attire."
  },
  {
    "name": "Non AC Wedding Bus Pune",
    "description": "Affordable non-AC wedding buses in Pune for short-distance travel, ideal for budget weddings or mild-weather days. These buses are well-ventilated, clean, and spacious—great for day ceremonies, receptions, or quick transfers between hotels and venues. Get cost-effective service without compromising on reliability."
  },
  {
    "name": "Pune Baraat Bus Rental",
    "description": "Dedicated buses for Baraat processions in Pune featuring stylish lighting, music systems, and open space for celebration. Designed to safely transport the groom’s party with flair and energy, these buses can be customized to match your wedding theme and include driver coordination for stops and timing."
  },
  {
    "name": "Family Bus Hire for Wedding Pune",
    "description": "Comfortable bus hire for families attending weddings in Pune, ensuring everyone stays together and enjoys seamless transfers to all ceremonies. Perfect for joint travel from outstations, multiple pickups within the city, and safe night-time return trips. Amenities include spacious seating, overhead storage, and courteous staff."
  },
  {
    "name": "Wedding Shuttle Service Pune",
    "description": "Efficient shuttle services for weddings in Pune to manage guest movement between venues, hotels, and parking areas. Shuttle buses run on a fixed schedule with optional signage, branding, and onboard assistance for elderly or outstation guests. Ideal for large weddings with multiple locations or limited parking."
  },
  {
    "name": "45 Seater Wedding Bus Pune",
    "description": "Spacious 45-seater wedding bus rentals in Pune designed for large groups. These buses come with wide windows, reclining seats, luggage racks, and entertainment options. Ideal for transporting guests from outstation locations or hosting in-city group commutes during sangeet, mehendi, or reception events."
  },
  {
    "name": "Deluxe Marriage Bus Hire Pune",
    "description": "Premium deluxe buses available for marriage functions in Pune, offering elegant interiors, AC climate control, plush seats, ambient lighting, and music systems. A perfect choice for VIP guest movement, groom or bride-side families, or stylish entry and exit during wedding functions and receptions."
  },
  {
    "name": "Online Bus Booking for Wedding Pune",
    "description": "Instant online bus booking platform for wedding events in Pune, allowing you to compare bus types, check availability, and secure your vehicle in just a few clicks. Choose from AC, non-AC, deluxe, or sleeper buses with optional decorations, GPS tracking, and 24/7 customer support."
  },
  {
    "name": "Bus for Reception Transport Pune",
    "description": "Reliable reception event bus rentals in Pune to ensure all your guests arrive and depart comfortably and on time. Buses can be scheduled for single or multiple trips, with onboard amenities to suit formal attire, gifts, and party mood. Coordination available with banquet halls and decorators."
  },
  {
    "name": "Wedding Ceremony Bus Service Pune",
    "description": "Timely and organized bus services for wedding ceremonies in Pune, handling guest pickups, venue transfers, and return travel. Each bus is assigned an event coordinator for managing arrival windows and ensuring that no one misses key moments of the wedding day. Ideal for mid to large-size events."
  },
  {
    "name": "Outstation Wedding Bus Hire Pune",
    "description": "Comfortable and long-distance wedding bus rental options from Pune to nearby towns or destinations. These outstation buses include luggage compartments, reclining seats, charging ports, and experienced drivers familiar with wedding travel timelines. Ideal for destination weddings or guests arriving from other cities."
  },
  {
    "name": "Marriage Event Transport Pune",
    "description": "All-inclusive transport services in Pune for marriage events covering the full range of needs—Baraat, guest shuttle, family buses, and reception night drop-offs. With a fleet ranging from 17 to 50 seaters, we handle your guest mobility while you focus on celebrations. Custom routes and timings available."
  }
],
"tableData": [
  ["Wedding Guest Bus Hire Pune", "AC Bus for Marriage in Pune"],
  ["Non AC Wedding Bus Pune", "Pune Baraat Bus Rental"],
  ["Family Bus Hire for Wedding Pune", "Wedding Shuttle Service Pune"],
  ["45 Seater Wedding Bus Pune", "Deluxe Marriage Bus Hire Pune"],
  ["Online Bus Booking for Wedding Pune", "Bus for Reception Transport Pune"],
  ["Wedding Ceremony Bus Service Pune", "Outstation Wedding Bus Hire Pune"],
  ["Marriage Event Transport Pune"]
],




    "whychoose": [
  {
    "WhyChooseheading": "Trusted Bus Hire for Wedding in Pune",
    "WhyChoosedescription": "Vaishnavi Travels specializes in reliable and convenient bus hire services for weddings across Pune, making guest transport effortless."
  },
  {
    "WhyChooseheading": "Comfortable Travel for Wedding Guests",
    "WhyChoosedescription": "Our spacious and well-equipped buses ensure a relaxed and comfortable journey for all your wedding guests."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Presentable Buses",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and serviced, with optional decoration available to match your wedding theme."
  },
  {
    "WhyChooseheading": "Flexible Rental Options for Wedding Events",
    "WhyChoosedescription": "Choose from various rental durations—hourly, full-day, or multiple days—to suit your wedding plans and guest movements."
  },
  {
    "WhyChooseheading": "Skilled Drivers with Local Expertise",
    "WhyChoosedescription": "Our trained drivers know Pune and surrounding areas well, ensuring punctual and safe transportation for your guests."
  },
  {
    "WhyChooseheading": "All-Inclusive and Transparent Pricing",
    "WhyChoosedescription": "Our pricing includes driver charges, fuel, tolls, and taxes, with no hidden costs—perfect for stress-free wedding planning."
  },
  {
    "WhyChooseheading": "Perfect for Baraat, Reception, and Guest Transport",
    "WhyChoosedescription": "From pre-wedding rituals to the main function, our buses are ideal for every part of your wedding celebration."
  },
  {
    "WhyChooseheading": "24/7 Assistance for Hassle-Free Coordination",
    "WhyChoosedescription": "Our support team is available round-the-clock to manage bookings, updates, and any last-minute changes."
  }
]





















  }










 const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer bus hire services for weddings in Pune?',
      answer: 'Yes, Vaishnavi Travels specializes in providing well-maintained and comfortable buses for wedding functions in Pune. Whether you need transportation for baraat, guests, or pre-wedding events, we ensure timely and professional service to make your special day hassle-free.',
    },
    {
      question: 'What seating capacities are available for wedding bus hires?',
      answer: 'We provide a range of options including 17-seater tempo travellers, 27-seater minibuses, 32-seater luxury coaches, and even 50-seater buses to meet the specific needs of your wedding event. Our fleet can handle small family gatherings to large guest lists with ease and comfort.',
    },
    {
      question: 'Can I book a bus for multiple days during the wedding?',
      answer: 'Absolutely. Many of our clients opt for multi-day rentals to cover all wedding functions such as Mehendi, Sangeet, wedding ceremony, and reception. We offer customizable packages to accommodate your full schedule and travel plans.',
    },
    {
      question: 'Are the wedding buses air-conditioned and clean?',
      answer: 'Yes, all our buses are fully air-conditioned, cleaned thoroughly before every trip, and sanitized regularly. We ensure that every vehicle is presented in a neat and hygienic condition to maintain the highest level of comfort for your guests.',
    },
    {
      question: 'Is driver service included in the wedding bus hire?',
      answer: 'Yes, every booking includes a licensed, uniformed, and experienced driver who is familiar with wedding logistics and guest etiquette. Our drivers are punctual and trained to handle routes and traffic efficiently, so you can focus on enjoying the occasion.',
    },
    {
      question: 'Can we request decorated buses for the wedding?',
      answer: 'Yes, upon request, we can arrange basic floral or ribbon decorations on the buses to match your wedding theme. For more elaborate decor, we coordinate with decorators or allow your team to personalize the vehicle prior to pickup.',
    },
    {
      question: 'What is the booking process for hiring a wedding bus in Pune?',
      answer: 'You can book a bus via our website, mobile app, or by calling our customer support. Simply share your requirements including number of guests, dates, and locations, and our team will suggest the best vehicle and package suited for your needs.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Suresh Jagtap",
    position: "Father of the Bride",
    feedback:
      "Hiring a wedding bus from Vaishnavi Travels was one of the best decisions we made. The vehicle was immaculately clean and well-maintained, and the guests were extremely comfortable throughout the journey. The driver was respectful, patient, and knew all the routes, ensuring no delays during the functions. The professionalism shown by their team truly added value to our big day.",
    rating: 5,
  },
  {
    name: "Ms. Shraddha Mehta",
    position: "Wedding Planner",
    feedback:
      "I’ve worked with several transport vendors, but Vaishnavi Travels really stood out. For a recent wedding in Pune, we hired multiple buses for guest pickup and drop. Not only were the vehicles on time and in pristine condition, but the coordination with their team was seamless. They accommodated last-minute changes without any hassle. My clients were extremely happy, and so was I. Highly recommended for any wedding event.",
    rating: 5,
    style: "style-2",
  },
];





































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Wedding in Pune",
  "image": "https://vaishnavitravel.com/assets/images/bus-hire-wedding-pune.jpg",
  "description": "Hire buses in Pune for wedding functions with Vaishnavi Travels. Choose from AC and Non-AC buses, 45-seaters, deluxe options, and shuttle services for wedding guests and family. Easy online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "2890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/bus-hire-for-wedding-in-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Bus Hire for Wedding in Pune | Guest & Family Transport | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Hire buses in Pune for wedding functions with Vaishnavi Travels. Choose from AC and Non-AC buses, 45-seaters, deluxe options, and shuttle services for wedding guests and family. Easy online booking available."
  />
  <meta
    name="keywords"
    content="Wedding Guest Bus Hire Pune, AC Bus for Marriage in Pune, Non AC Wedding Bus Pune, Pune Baraat Bus Rental, Family Bus Hire for Wedding Pune, Wedding Shuttle Service Pune, 45 Seater Wedding Bus Pune, Deluxe Marriage Bus Hire Pune, Online Bus Booking for Wedding Pune, Bus for Reception Transport Pune, Wedding Ceremony Bus Service Pune, Outstation Wedding Bus Hire Pune, Marriage Event Transport Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforweddinginpune;